import React, { useEffect, useRef, useState } from "react";

interface IframeI {
  data: {
    IframeHeight: string;
    IframeHeightUnits: "px" | "%";
    IframeUrl: string;
    idComponent?: string
  };
}

const Iframe = ({ data }: IframeI) => {
  const {
    IframeHeight = "0",
    IframeHeightUnits = "px",
    IframeUrl,
    idComponent
  } = data;

  const frameRef = useRef<HTMLIFrameElement>(null);
  const [autoHeight, setAutoHeight] = useState<number | null>(null);

  // Auto-resize: la página embebida (p.ej. los formularios del CRM,
  // crm.life5.com/f/*?embed=1) publica su altura real con
  // postMessage({ type: 'crm-form:height', height }). Solo se aceptan mensajes
  // cuyo origin coincide con el del IframeUrl y cuyo source es este iframe.
  // El IframeHeight de Strapi queda como altura inicial/fallback.
  useEffect(() => {
    let frameOrigin: string;
    try {
      frameOrigin = new URL(IframeUrl, window.location.href).origin;
    } catch {
      return;
    }
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== frameOrigin) return;
      if (!frameRef.current || event.source !== frameRef.current.contentWindow) return;
      const message = event.data as { type?: string; height?: number } | null;
      if (!message || message.type !== "crm-form:height") return;
      if (typeof message.height !== "number" || !Number.isFinite(message.height) || message.height <= 0) return;
      setAutoHeight(Math.ceil(message.height));
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [IframeUrl]);

  return (
    <section className="overflow-hidden" id={idComponent ?? ""}>
      <div className="max-w-content mx-auto py-[64px] xl:px-[0px] px-[24px]">
        <iframe
          ref={frameRef}
          src={IframeUrl}
          className="w-full"
          style={{
            height: autoHeight !== null ? `${autoHeight}px` : `${IframeHeight}${IframeHeightUnits}`,
            border: 0
          }}
        />
      </div>
    </section>
  );
};

export default Iframe;
